<template>
    <b-card no-body>
        <b-card-body>
            <h4 class="heading-1 mb-4">
                <span
                    >CONTRATOS -
                    {{
                        operacao == 'I'
                            ? 'NOVA REQUISIÇÃO'
                            : 'ATUALIZAÇÃO DA REQUISIÇÃO'
                    }}</span
                >
            </h4>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Contrato</label>
                        <model-list-select
                            :list="contratos"
                            option-text="codContratoFornecedor"
                            option-value="idContrato"
                            v-model="idContrato"
                            :isDisabled="desabilitarAlterarContrato"
                        >
                        </model-list-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div v-if="contrato">
                        <detalhe titulo="Vigência" :size="size1"
                            >{{
                                $moment(contrato.dtInicioVigencia).format(
                                    'DD/MM/YYYY'
                                )
                            }}
                            a
                            {{
                                $moment(contrato.dtFimVigencia).format(
                                    'DD/MM/YYYY'
                                )
                            }}</detalhe
                        >
                        <detalhe titulo="Saldo do Contrato" :size="size1">{{
                            contrato.nuSaldoContrato | currency
                        }}</detalhe>
                    </div>
                </b-col>
            </b-row>
            <div v-if="contrato">
                <h5 class="heading-1 mt-4">
                    <span>DADOS DO PROCESSO</span>
                </h5>
                <b-row>
                    <b-col>
                        <div v-if="processo">
                            <detalhe titulo="Interessado" :size="size1">{{
                                processo.nome
                            }}</detalhe>
                            <detalhe titulo="Criado por" :size="size1">{{
                                processo.cadastradoPor
                            }}</detalhe>
                            <detalhe titulo="Unidade" :size="size1">{{
                                processo.unidade
                            }}</detalhe>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-form-group>
                            <label>Objeto</label>
                            <b-form-textarea
                                v-model="objeto"
                                :rows="4"
                                :disabled="naoPermiteAtualizar"
                            ></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-form-group>
                            <label>Texto Complementar</label>
                            <b-form-textarea
                                v-model="textoComplementar"
                                :rows="4"
                                :disabled="naoPermiteAtualizar"
                            ></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <b-checkbox
                                v-model="naoRequerAutorizacaoEnvio"
                                :disabled="naoPermiteAtualizar"
                                class="pt-2"
                                >Não requer envio</b-checkbox
                            >
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <div v-if="contrato">
                <h5 class="heading-1 mb-4 mt-4">
                    <span>DADOS DA REQUISIÇÃO</span>
                </h5>
                <b-row>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <label>Solicitante</label>
                            <model-list-select
                                :list="solicitantes"
                                option-text="nome"
                                option-value="codFuncionario"
                                v-model="codSolicitante"
                                :isDisabled="naoPermiteAtualizar"
                            >
                            </model-list-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <label>Contato do Solicitante</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    v-model="contatoSolicitante"
                                    :disabled="naoPermiteAtualizar"
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label>Data da Necessidade</label>
                            <date-picker
                                v-model="dataNecessidade"
                                :config="$datePickerOptions2"
                                v-mask="'##/##/####'"
                                :disabled="naoPermiteAtualizar"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label>Data Entrada UABS</label>
                            <date-picker
                                v-model="dataEntrada"
                                :config="$datePickerOptions2"
                                v-mask="'##/##/####'"
                                :disabled="naoPermiteAtualizar"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
        </b-card-body>
        <b-card-footer>
            <b-button variant="danger" @click.stop="voltar()" class="mr-1">
                <span> <i class="fa fa-history"></i> Cancelar </span>
            </b-button>
            <b-button
                variant="primary"
                :disabled="desabilitarBtnSalvar"
                v-if="!naoPermiteAtualizar"
                @click.stop="confirmaSalvar()"
            >
                <i class="fa fa-save"></i> Salvar
            </b-button>
        </b-card-footer>
    </b-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import RequisicoesServicos from './RequisicoesServicos'
import { ModelListSelect } from 'vue-search-select'

export default {
    props: {
        operacao: {
            type: String
        },

        errosPai: {
            type: Array
        },

        requisicao: {
            type: Object
        },

        naoPermiteAtualizar: {
            type: Boolean,
            default: () => false
        }
    },

    components: {
        ModelListSelect
    },

    data() {
        return {
            size1: '130',
            erros: [],
            contratos: [],
            contrato: null,
            idContrato: null,
            numProcesso: null,
            processo: null,
            objeto: null,
            textoComplementar: null,
            contatoSolicitante: null,
            dataNecessidade: null,
            dataEntrada: null,
            codSolicitante: null,
            solicitantes: [],
            naoRequerAutorizacaoEnvio: false
        }
    },

    methods: {
        voltar() {
            this.$router.push({
                name: 'Contratos_Requisicoes'
            })
        },

        obterContratos() {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.obterContratos().then((response) => {
                if (response) {
                    if (response.success) {
                        this.contratos = response.data
                        if (this.operacao == 'A') {
                            this.preencherFormulario()
                        }
                    } else {
                        this.erros.push('Erro ao obter contratos')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterContrato() {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.obterContrato(this.idContrato).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.contrato = response.data
                            this.obterSolicitantes()
                        } else {
                            this.erros.push('Erro ao obter contrato')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        preencherFormulario() {
            this.idContrato = this.requisicao.idContrato
            this.numProcesso = this.requisicao.processo
            this.objeto = this.requisicao.objeto
            this.textoComplementar = this.requisicao.textoComplementar
            this.contatoSolicitante = this.requisicao.contatoSolicitante
            this.dataNecessidade = this.$moment(
                this.requisicao.dataNecessidade
            ).format('DD/MM/YYYY')
            this.dataEntrada = this.$moment(
                this.requisicao.dataRequisicao
            ).format('DD/MM/YYYY')
            this.codSolicitante = this.requisicao.codSolicitante
            this.naoRequerAutorizacaoEnvio =
                this.requisicao.naoRequerAutorizacaoEnvio
            if (this.requisicao.informadoProcesso) {
                this.obterProcesso()
            }
        },

        obterProcesso() {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.obterProcesso(
                this.numProcesso,
                this.operacao
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.erros = []
                        this.processo = response.data
                    } else {
                        this.erros.push(response.errors[0])
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        limparProcesso() {
            this.processo = null
        },

        obterSolicitantes() {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.obterSolicitantes().then((response) => {
                if (response) {
                    if (response.success) {
                        this.solicitantes = response.data
                    } else {
                        this.erros.push('Erro ao obter solicitantes')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmaSalvar() {
            let acao = ''
            let titulo = ''
            if (this.operacao == 'I') {
                acao = 'a inserção'
                titulo = 'Inserção'
            } else if (this.operacao == 'A') {
                acao = 'a atualização'
                titulo = 'Atualização'
            }

            this.$swal({
                title: titulo,
                html: `Confirma ${acao} da requisicao para o contrato <b>${this.contrato.vcCodigoEstruturado}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            let requisicaoDto = {
                idContrato: this.idContrato,
                numProcesso: '',
                naoRequerAutorizacaoEnvio: this.naoRequerAutorizacaoEnvio,
                objeto: this.objeto,
                textoComplementar: this.textoComplementar,
                codSolicitante: this.codSolicitante,
                contatoSolicitante: this.contatoSolicitante,
                dataNecessidade: this.$moment(
                    this.dataNecessidade,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD'),
                dataEntrada: this.$moment(
                    this.dataEntrada,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }
            if (this.contrato.utilizarProcesso) {
                requisicaoDto.numProcesso = this.numProcesso
            }
            this.$emit('salvar', requisicaoDto)
        }
    },

    created() {
        this.obterContratos()
        this.dataNecessidade = this.$moment(new Date()).format('DD/MM/YYYY')
        this.dataEntrada = this.$moment(new Date()).format('DD/MM/YYYY')
        if (this.errosPai) {
            this.erros = [...this.errosPai]
        }
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },

        desabilitarAlterarContrato() {
            if (
                this.requisicao &&
                this.requisicao.comprometimentos &&
                this.requisicao.comprometimentos.length > 0
            ) {
                return true
            }
            if (
                this.requisicao &&
                this.requisicao.itens &&
                this.requisicao.itens.length > 0
            ) {
                return true
            }
            return false
        }
    },

    watch: {
        idContrato() {
            this.obterContrato()
        },

        processo() {
            this.objeto = this.processo ? this.processo.assunto : null
        },

        errosPai() {
            this.erros = [...this.errosPai]
        }
    },

    validations: {
        idContrato: {
            required
        },
        objeto: {
            required
        },
        dataNecessidade: {
            required
        },
        dataEntrada: {
            required
        },
        codSolicitante: {
            required
        }
    }
}
</script>
